/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ConversationsItemsDeleteRequest = {
  conversationId: string;
  itemId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ConversationsItemsDeleteRequest$inboundSchema: z.ZodType<
  ConversationsItemsDeleteRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  conversation_id: z.string(),
  item_id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "conversation_id": "conversationId",
    "item_id": "itemId",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ConversationsItemsDeleteRequest$Outbound = {
  conversation_id: string;
  item_id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ConversationsItemsDeleteRequest$outboundSchema: z.ZodType<
  ConversationsItemsDeleteRequest$Outbound,
  z.ZodTypeDef,
  ConversationsItemsDeleteRequest
> = z.object({
  conversationId: z.string(),
  itemId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    conversationId: "conversation_id",
    itemId: "item_id",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function conversationsItemsDeleteRequestToJSON(
  conversationsItemsDeleteRequest: ConversationsItemsDeleteRequest,
): string {
  return JSON.stringify(
    ConversationsItemsDeleteRequest$outboundSchema.parse(
      conversationsItemsDeleteRequest,
    ),
  );
}
export function conversationsItemsDeleteRequestFromJSON(
  jsonString: string,
): SafeParseResult<ConversationsItemsDeleteRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ConversationsItemsDeleteRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConversationsItemsDeleteRequest' from JSON`,
  );
}
